module.exports = __webpack_public_path__ + "static/media/DerrickMasters.a5c376e9.jpg";